// extracted by mini-css-extract-plugin
export default {"container":"Tabela_container__-O7z7"};